// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.show .p-inputgroup {
  max-width: 20rem;
}`, "",{"version":3,"sources":["webpack://./src/app/app.topbar.scss"],"names":[],"mappings":"AAEI;EACI,gBAAA;AADR","sourcesContent":["\n.show{\n    .p-inputgroup{\n        max-width:20rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
